import {initSvgIcon} from "../utils/icon";
import {map} from "./mapFilter.js";
import {isEmpty} from "../utils/utils";
import {masonryCardInstantane} from "../templates/archive-instantane";
import {initDepartment} from "../templates/archive-actus";
import {noBreackingSpace} from "../elements/noBreackingPoints";

export let listposts = $("#list-posts");

export let inputPage = $('#filtres input[name=page]')
export let inputPostsPerPage = $('#filtres input[name=posts_per_page]')
export let originalPostsPerPage = inputPostsPerPage.val();
export let inputContainer = $('#filtres input[name=container_post]')
export let buttonMore = $("#view_more")

const PREFIX_TAG_URL = 'tax-';

let loader = "<div class='browser-screen-loading-content pb-8'>"+
                "<div class='loading-dots dark-gray'>"+
                    "<i></i><i></i><i></i><i></i>"+
                "</div>"+
            "</div>"

if (listposts.length) {

    //Init
    loadUrl()
    updateView()
    reloadPosts()
    $("#filtres .list-terms").eq(0).addClass('active')
    $("#filtres .selected-taxonomy").eq(0).addClass('selected')

    ///////////
    // EVENT //
    ///////////


    // On view more
    buttonMore.click(function (e) {
        e.preventDefault()
        reloadPosts(getCurrentPage()+1)
    })

    // On filtering
    $('#filtres input').change(function () {
        if ($('.page-template-archive-instantane').length || $('.page-template-archive-ressources-analyses').length) {
            focusInput($(this))
        }
        if ($('.page-template-archive-ressources-analyses').length) {
            inputPostsPerPage.val('14')
        }
        updateView()
        reloadPosts(1)
    })
    //On filtering | press enter focus on taxonomy button
    $('#filtres .checkbox label').keypress(function(event){
        if(event.keyCode == 13) {
            let input = $(this).parent().find('input[type="checkbox"]')
            let checked = input.is(':checked')
            input.prop('checked', !checked)
            $(this).parent().toggleClass('checked')
            focusInput(input)
            //
            updateView()
            reloadPosts(1)
        }
    });

    //Reset Filter
    $("#filtres .filter_all, #filtres .clear-filter, #filtres .reset-filter").click(function (e) {
        e.preventDefault()
        inputPostsPerPage.val(originalPostsPerPage)
        resetFilter()
    }).keypress(function(e){
        if(e.keyCode === 13) resetFilter()
    });


    //Show filter menu on mobile
    $("#show_filter").click(function () {
        if ($(window).width() <= 767) $('.filter').slideDown()
    })
    //Hide filter menu on mobile
    $("#close_menu, .clear-filter, .filter_all").click(function (e) {
        e.preventDefault()
        if ($(window).width() <= 767) {
            $('.filter').slideUp(400, function () {
                $('.filter').attr('style', '')
            });
        }
    })


    //Expend filter menu on desktop
    $('.filter .multi-select .label').click(function () {
        if (!device.mobile() && !device.tablet()) {
            let multiSelect = $(this).parent()
            if (multiSelect.hasClass('active')) {
                $('html, body').animate({
                    scrollTop: multiSelect.offset().top - 50
                }, 400);
                setTimeout(function () {
                    let height = multiSelect.find('.items').innerHeight()
                    $('#content_result').css('min-height', height+'px')
                }, 150)
            } else {
                $('#content_result').css('min-height', '')
            }
        }
    })

    ///////////////
    // FUNCTIONS //
    ///////////////

    function focusInput(currentInput) {
        let inputs = $("#filtres input:checked")
        inputs.each(function () {
            // console.log($(this), currentInput)
            if ($(this).attr('id') != currentInput.attr('id')) {
                $(this).parent().removeClass('checked');
                $(this).prop('checked', false);
            }
        })
    }

    function resetFilter() {
        //Uncheck all input
        let inputs = $("#filtres input:checked")
        inputs.parent().removeClass('checked');
        inputs.prop('checked', false);
        //Check default value of radio input
        $("#filtres input[type=radio][checked]").prop('checked', true);
        $("#filtres input[type=radio][checked]").parent().addClass('checked');
        //
        updateView()
        reloadPosts(1)
    }

    function getCurrentPage() {
        return parseInt(inputPage.val())
    }

    function updateView() {
        // $("#filtres .selected-taxonomy").each(function () {
        //     let taxonomy = $(this).data('taxonomy')
        //     let number = $("#filtres .list-terms input[data-taxonomy="+taxonomy+"]:checked").length;
        //     if (number) {
        //         $(this).find('span').html(number)
        //     } else {
        //         $(this).find('span').html('')
        //     }
        // })
        if ($("#filtres input:checked").length) {
            $('.filter_all').removeClass('checked');
        } else {
            $('.filter_all').addClass('checked');
        }
        initSvgIcon()
    }


    //Reload post result
    function reloadPosts(page = null) {
        buttonMore.hide();
        buttonMore.after(loader)
        // Ajax rest query
        fetch(resturl+'loadposts', {
            method: 'POST',
            headers: {'Accept': 'application/json'},
            body: JSON.stringify(getQuery(page)),
        }).then(function (res) {
            if (res.ok) return res.json()
        }).then(function (data) {
            if (data.posts) {
                if (data.query.paged === 1) {
                    listposts.html(data.posts)
                } else {
                    listposts.append(data.posts)
                }
            }
            setTimeout(() => masonryCardInstantane(), 0)
            if (data.maps) {
                map.clearMarkers()
                map.load_WP_Post(data.maps)
            }

            updateUrl();
            noBreackingSpace(listposts)

            let posts_per_page = data.post.posts_per_page
            let current_page = parseInt(inputPage.val())
            let found_posts =  data.found_posts
            // console.log("--------------------")
            // console.log("posts_per_page: "+posts_per_page)
            // console.log("current_page: "+current_page)
            // console.log("found_posts: "+found_posts)
            // console.log("article already show: "+posts_per_page*current_page)

            buttonMore.hide();
            $('.browser-screen-loading-content').remove();
            //if all article is show
            console.log(posts_per_page, current_page, found_posts)
            if ((posts_per_page * current_page) >= found_posts) {
                buttonMore.hide()
            } else {
                buttonMore.show()
            }

            buttonMore.prop('disabled', false)
        }).catch(function (error) {
            console.log(error)
        })
    }

    function getQuery(page) {
        if (page == null) {
            page = inputPage.val()
        } else {
            inputPage.val(page)
        }
        //
        let query = {};
        let terms = {};
        let forms = $("form#filtres").get();
        for (let i = 0; i < forms.length; i++) {
            let data = new FormData(forms[i]);
            data.forEach(function(value, key){
                if (key.includes('terms')) {
                    let taxonomy = key.replace('terms[', '').replace('][]', '');
                    if (!terms[taxonomy]) terms[taxonomy] = [];
                    terms[taxonomy].push(value);
                } else {
                    query[key] = value;
                }
            });
        }
        if (terms) query['terms'] = terms;
        if (page) query["page"] = page;

        return query;
    }

    //Change Url with taxonomy checkbox
    function updateUrl() {
        let taxonomys = getQuery().terms;
        let queryParams = new URLSearchParams(window.location.search);
        if (!isEmpty(taxonomys)) {
            $.each(taxonomys, function(index, value) {
                queryParams.set(PREFIX_TAG_URL+index, encodeURI(value));
            });
            history.replaceState(null, null, "?"+queryParams.toString());
        } else {
            history.replaceState(null, null, "?");
        }
    }

    //Autoselect Input with url taxonomy args
    function loadUrl() {
        //Get Url params
        let taxonomys = {}
        let queryParams = new URLSearchParams(window.location.search);
        queryParams.forEach((value, index) => {
            if (index.startsWith(PREFIX_TAG_URL)) {
                let taxonomy = index.replace(PREFIX_TAG_URL, '')
                taxonomys[taxonomy] = value.split(",");
            }
        })
        //Select input filter
        if (!isEmpty(taxonomys)) {
            if ($('.page-template-archive-ressources-analyses').length) {
                inputPostsPerPage.val('14')
            }
            $.each(taxonomys, function(taxonomy, terms) {
                terms.forEach((term) => {
                    let checkbox = $("#filtres input[data-taxonomy="+taxonomy+"][value="+term+"]")
                    checkbox.parents('.input-checkbox').addClass('checked');
                    checkbox.parents('.checkbox').addClass('checked');
                    checkbox.prop('checked', true);
                })
            });
        }
        initDepartment()
    }
}
